import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconErrorFilled = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g><path fill="currentColor" d="M31.385 14.48 17.52.62A2.15 2.15 0 0 0 16 0c-.54 0-1.1.2-1.52.62L.614 14.48c-.82.84-.82 2.2 0 3.04L14.48 31.38c.42.42.98.62 1.52.62s1.1-.2 1.52-.62l13.865-13.86c.82-.84.82-2.2 0-3.04M15 9.18c0-.56.44-1 1-1s1 .44 1 1v9.1c0 .56-.44 1-1 1s-1-.44-1-1zm1 14.64c-.72 0-1.3-.58-1.3-1.3s.58-1.3 1.3-1.3 1.3.58 1.3 1.3-.58 1.3-1.3 1.3" /></g></svg>;
export default SvgIconErrorFilled;